import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import '../styles/Technology.css';

const Technology = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="technology" className="technology-section">
      <div className="section-container">
        <h2>{t.techTitle}</h2>
        <div className="tech-list">
          <div className="tech-item">
            <p>{t.tech1}</p>
          </div>
          <div className="tech-item">
            <p>{t.tech2}</p>
          </div>
          <div className="tech-item">
            <p>{t.tech3}</p>
          </div>
          <div className="tech-item">
            <p>{t.tech4}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;